var showHideScrollToTop = function () {
    if(window.scrollY >= 250) {
        document.getElementById("scroll-to-top").classList.remove("hidden");
    } else {
        document.getElementById("scroll-to-top").classList.add("hidden");
    }
};

document.addEventListener("DOMContentLoaded", showHideScrollToTop);
window.addEventListener("scroll", showHideScrollToTop);